import React from 'react';

export default function Badge({
  tagClass,
  tagContent,
  upperCase = true,
  icon = null,
}: {
  tagClass: string;
  tagContent: string;
  upperCase?: boolean;
  icon?: React.JSX.Element | null;
}) {
  return (
    <div
      className={`flex font-rp-basetica items-center justify-center p-1 rounded text-xs leading-14px w-fit gap-1 ${tagClass} ${
        upperCase ? 'uppercase' : ''
      }`}
    >
      {icon}
      {tagContent}
    </div>
  );
}
